import * as React from "react";
import { Modal, Button } from "antd";

export interface State {}

export interface Props {
  translate: any;
  visible?: boolean;
  onOk?: any;
  onCancel: any;
}

export default class RemoveSectionModal extends React.Component<Props, State> {
  render() {
    const { translate, visible, onOk, onCancel, children } = this.props;

    return (
      <div>
        <Modal
          title={translate("remove_section_modal.title")}
          visible={visible}
          onCancel={onCancel}
          maskClosable={false}
          onOk={onOk}
          footer={[
            <Button key="back" onClick={onCancel}>
              {translate("modal_functions.remove_modal.cancel")}
            </Button>,
            <Button key="submit" type="danger" onClick={onOk}>
              {translate("modal_functions.remove_modal.remove")}
            </Button>
          ]}
        >
          {children}
        </Modal>
      </div>
    );
  }
}
